import Widget from "Components/Common/Widget/Widget";
import React, { useEffect, useState } from "react";
import { FaSortAmountUpAlt } from "react-icons/fa";
import { FaGift } from "react-icons/fa6";
import { MdEmojiEmotions } from "react-icons/md";
import { getAllEmojis } from "Common Usage/apiService";
import AddCoinsForm from "./components/AddCoinsForm";
import CoinsList from "./components/CoinsList";
import axios from "axios";
// import { featchPromoPlan } from 'Common Usage/apiService';

const Coins = () => {
  const [addCoinModal, setAddCoinModal] = useState(false);
  const [coinDataLoading, setCoinDataLoading] = useState(true);
  const [coinPlans, setCoinPlans] = useState([]);
  // const [promoPlans, setPromoPlans] = useState([]);

  // const fetchAllEmojis = async () => {
  //   try {
  //     const data = await getAllEmojis();
  //     setAllEmojis(data);
  //   } catch (error) {
  //     console.log("getAllEmojis-Error", error.message);
  //   } finally {
  //     setEmojiDataLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchCoinPlans();
    // featchPromoPlan();
  }, []);

  const fetchCoinPlans = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/coin-plan/getcoin-plans`
      );
      setCoinPlans(response?.data);
      // console.log("Coin Plans:", response?.dataa);
      setCoinDataLoading(false);
    } catch (error) {
      console.log("Error fetching coin plans:", error);
    }
  };

  const handleAddModalOpen = () => setAddCoinModal(true);
  const handleAddModalClose = () => setAddCoinModal(false);

  return (
    <React.Fragment>
      <AddCoinsForm
        // promoPlans={promoPlans}
        addEmojiModal={addCoinModal}
        handleAddModalClose={handleAddModalClose}
        fetchCoinPlans={fetchCoinPlans}
      />
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<FaGift className="h-6 w-6" />}
          title={"Total No. of Coin Packages"}
          subtitle={coinPlans.length}
        />
        <Widget
          icon={<FaSortAmountUpAlt className="h-6 w-6" />}
          title={"Total Amount of Coin Packages"}
          subtitle={"34"}
        />
        <Widget
          icon={<MdEmojiEmotions className="h-6 w-6" />}
          title={"Total Coin package purchase"}
          subtitle={"23"}
        />
      </div>
      <CoinsList
        coinPlans={coinPlans}
        // promoPlans={promoPlans}
        fetchCoinPlans={fetchCoinPlans}
        handleAddModalOpen={handleAddModalOpen}
        coinDataLoading={coinDataLoading}
      />
    </React.Fragment>
  );
};

export default Coins;
